//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false */

/**
* A service for recording UIA user routes for later analysis of user behavior.
* Keeping this logic in it's own service avoids tight coupling between the
* ProductTaggingService service, universalImageActionsProductize directive,
* universalImageActionsProductizeEditor directive, and the universalImageActionsProductizeTypeahead directive.
*/
(function() {
  const curalate = angular.module('curalate');

  curalate.service('UniversalImageActionsTrackingService', [
    '$http',
    '$q',
    '$rootScope',
    'PromiseService',
    function(
      $http,
      $q,
      $rootScope,
      PromiseService,
    ) {
      /**
      * A route that tracks a user:
      *  1) viewing a target image
      *  2) searching the product service
      *  3) tagging the image with a product.
      */
      const tagQuerySaveProductRoute = {
        imageUrl: undefined,
        queryParams: undefined,
        queryResults: undefined,
        product: undefined,
      };

      //
      // Setters accessed by other services or directives.
      //
      $rootScope.$on('uia:modal:image-url-changed', ($event, newImage) => {
        tagQuerySaveProductRoute.imageUrl = newImage.canonicalImageUrl;
      });
      this.setQueryParams = function(params) {
        tagQuerySaveProductRoute.queryParams = params;
      };
      this.getQueryParams = function() {
        return {
          ...tagQuerySaveProductRoute.queryParams,
        };
      };
      this.clearQueryParams = function() {
        tagQuerySaveProductRoute.queryParams = undefined;
      };
      this.setQueryResults = function(results) {
        tagQuerySaveProductRoute.queryResults = results;
      };
      this.setProduct = function(product) {
        tagQuerySaveProductRoute.product = product;
      };

      //
      // saves the current state to the REST api...
      //

      this.saveRoute = function() {
        PromiseService
        .processHttpResponse($http.put('/api/universal-image-actions/tracking/tag-query-save-product-route', tagQuerySaveProductRoute))
        .catch(angular.noop);
      };
    },
  ]);
})();

